import { atom } from 'recoil'
import { IMeRegistrations } from 'screens/Protection/protection.types'

interface IProtectionsTableAtom {
  items: IMeRegistrations[]
}

const protectionsTableAtom = atom<IProtectionsTableAtom>({
  key: 'tables/student/protections',
  default: { items: [] },
})
export default protectionsTableAtom
